import styled from '@emotion/styled'
import { isMobile } from '@const/device'

const DesktopPdfFrame = styled.iframe<{ inModal: boolean; isLandscape: boolean }>`
  width: ${({ inModal }) => (inModal ? 'calc(100vw - 150px)' : '78vw')};
  height: ${({ inModal }) => (inModal ? '100vh' : '90%')};
  background: ${({ theme }) => theme.colors.background.surface};
  box-shadow: ${({ inModal }) =>
    inModal ? 'none' : '5px 5px 20px rgba(29, 78, 137, 0.1)'};
  border-radius: 15px;
  /* Лист PDF без полей — убран внутренний отступ вокруг документа. */
  padding: 0;
`

const MobilePdfFrame = styled(DesktopPdfFrame)<{
  inModal: boolean
  isLandscape: boolean
}>`
  height: ${({ inModal, isLandscape }) =>
    inModal ? (isLandscape ? '75vh' : '80vh') : '65vh'};
  width: ${({ inModal }) => (inModal ? '100vw' : '95vw')};
`

export const PdfFrame = isMobile ? MobilePdfFrame : DesktopPdfFrame
